import {createContext} from 'react'

export const PeekCarouselContext = createContext(false)
